<script lang="ts">
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Helpers
	import { get_local_ip } from '../../../../helpers/interface_helpers';
	//Design system components
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	const min = 0;
	const max = 10000;
	let loading = false;

	let settings = readDeviceSettings(device.id);
	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore ?? settings;

	let value = settings['rollers'][device.channel].ends_delay;
	let cache = value;
	let localIp = get_local_ip(device.id);

	const setEdnsDelay = async () => {
		if (cache !== value) {
			let res: any = {};
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings/${device.category}/0`, 'post', {
					ends_delay: +value,
				});
			} else {
				res = await postReq(`device/generic_command`, {
					id: device.id,
					command: 'ends_delay',
					payload: JSON.stringify({
						id: device.channel,
						delay: +value,
					}),
				});
			}
			if (res.isok) {
				settings['rollers'][device.channel].ends_delay = value;
				toast.open({
					type: 'success',
					title: $format('setting_scc_saved_toast'),
				});
				devices_settings.update_devices_settings(device.id, settings);
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('description_for_opening_working_time', {
		values: { value: value, min, max },
	})}
</Text>
<Input
	size="m"
	class="mb-s"
	bind:value
	type="number"
	icon="fas fa-clock"
	{min}
	{max}
	on:enter={setEdnsDelay}
	id="input-iwsvfe5"
	aria-label={$format('description_for_opening_working_time', {
		values: { value: value, min, max },
	})}
/>

<Button class="mt-s" {loading} size="m" width="full" on:click={setEdnsDelay}>
	{$format('button_save')}
</Button>
